import { render, staticRenderFns } from "./Transportations.vue?vue&type=template&id=22611d3e&scoped=true&"
import script from "./Transportations.vue?vue&type=script&lang=js&"
export * from "./Transportations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22611d3e",
  null
  
)

export default component.exports